module.exports = __webpack_public_path__ + "img/industry_back.b062d80c.jpg";